<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations">
          <div class="filters">
            <el-form :inline="true" label-width="70px" label-position="left">
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('baseInfo.customsCommodityCode.code')">
                  <el-input
                    v-model="searchConditions.code"
                    style="width: 260px"
                    size="mini"
                    @change="searchConditions.pageNum=1"
                  />
                </el-form-item>
                <el-form-item :label="$t('baseInfo.customsCommodityCode.commodityName')">
                  <el-input
                    v-model="searchConditions.commodityName"
                    style="width: 260px"
                    size="mini"
                    @change="searchConditions.pageNum=1"
                    @keyup.enter.native="fetchCommodityCodeList"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="triggers">
            <div>
              <el-button size="mini" style="height: 28px" type="primary" @click="fetchCommodityCodeList">{{ $t('common.btn.query') }}</el-button>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="100401"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            config-module="100401"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchCommodityCodeList"
          />
        </div>
      </div>
    </div>
    <!-- 海关商品编码维护 -->
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="isShowCustomsCommodityCodeMaintain"
      :title="$t('baseInfo.customsCommodityCode.customsCommodityCodeMaintain')"
      inline-message
      width="50%"
    >
      <el-form
        ref="customsCommodityCodeForm"
        :model="customsCommodityCodeForm"
        label-width="120px"
        label-position="right"
      >
        <el-form-item :label="$t('baseInfo.customsCommodityCode.countryCode')" prop="countryCode">
          <el-input v-model="customsCommodityCodeForm.countryCode" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.customsCommodityCode.code')" prop="code">
          <el-input v-model="customsCommodityCodeForm.code" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.customsCommodityCode.commodityName')" prop="commodityName">
          <el-input v-model="customsCommodityCodeForm.commodityName" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.customsCommodityCode.mfnRate')" prop="mfnRate">
          <el-input v-model="customsCommodityCodeForm.mfnRate" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.customsCommodityCode.generalRate')" prop="generalRate">
          <el-input v-model="customsCommodityCodeForm.generalRate" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.customsCommodityCode.vat')" prop="vat">
          <el-input v-model="customsCommodityCodeForm.vat" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.customsCommodityCode.legalUnit')" prop="legalUnit">
          <el-input v-model="customsCommodityCodeForm.legalUnit" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.customsCommodityCode.secondUnit')" prop="secondUnit">
          <el-input v-model="customsCommodityCodeForm.secondUnit" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.customsCommodityCode.superviseMode')" prop="superviseMode">
          <el-input v-model="customsCommodityCodeForm.superviseMode" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.customsCommodityCode.mscCommodity')" prop="mscCommodity">
          <el-input
            v-model="customsCommodityCodeForm.mscCommodity"
            type="textarea"
            :maxlength="255"
            :rows="6"
            size="mini"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="medium " type="primary" @click="submitCustomsCommodityCode">{{ $t('common.btn.save') }}
        </el-button>
        <el-button size="medium " @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import URL from '@/api/urlTranslator'
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import {
  getCustomsCommodityCodeList,
  batchDelCustomsCommodityCode,
  updateCustomsCommodityCode,
  addCustomsCommodityCode
} from '@/api/customsCommodityCode'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'CustomsCommodityCode',
  components: { },
  data() {
    return {
      codeTitle: this.$t('baseInfo.customsCommodityCode.code') + ':',
      commodityNameTitle: this.$t('baseInfo.customsCommodityCode.commodityName') + ':',
      searchConditions: {
        code: '',
        commodityName: '',
        pageNum: 1,
        pageSize: 10,
        total: 4
      },
      gridOptions: {
        rowClassRules: {
          'grid-row-zebra-even': function(params) {
            return !(params.rowIndex % 2)
          },
          'grid-row-zebra-odd': function(params) {
            return (params.rowIndex % 2)
          }
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        paginationNumberFormatter: function(params) {
          return '[' + params.value.toLocaleString() + ']'
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      gridParams: {},
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.customsCommodityCode.code'),
          field: 'code'
        }, {
          headerName: this.$t('baseInfo.customsCommodityCode.commodityName'),
          field: 'commodityName'
        }, {
          headerName: this.$t('baseInfo.customsCommodityCode.mfnRate'),
          field: 'mfnRate'
        }, {
          headerName: this.$t('baseInfo.customsCommodityCode.generalRate'),
          field: 'generalRate'
        }, {
          headerName: this.$t('baseInfo.customsCommodityCode.vat'),
          field: 'vat'
        }, {
          headerName: this.$t('baseInfo.customsCommodityCode.legalUnit'),
          field: 'legalUnit'
        }, {
          headerName: this.$t('baseInfo.customsCommodityCode.mscCommodity'),
          field: 'mscCommodity'
        }, {
          headerName: this.$t('baseInfo.customsCommodityCode.secondUnit'),
          field: 'secondUnit'
        }, {
          headerName: this.$t('baseInfo.customsCommodityCode.superviseMode'),
          field: 'superviseMode'
        }],
      isShowCustomsCommodityCodeMaintain: false,
      customsCommodityCodeForm: {
        countryCode: '',
        code: '',
        commodityName: '',
        mfnRate: '',
        generalRate: '',
        vat: '',
        legalUnit: '',
        secondUnit: '',
        superviseMode: ''
      },
      fullscreenLoading: null
    }
  },
  computed: {
    url() {
      return URL
    }
  },
  mounted() {
    this.fetchCommodityCodeList()
  },
  methods: {
    fetchCommodityCodeList() {
      const self = this
      self.fullscreenLoading = getLoading()
      const params = { ...this.searchConditions }
      getCustomsCommodityCodeList(params).then(res => {
        if (res.ok) {
          self.rowData = res.data.list
          self.searchConditions.pageNum = res.data.pageNum
          self.searchConditions.pageSize = res.data.pageSize
          self.searchConditions.total = Number(res.data.total)
          self.fullscreenLoading.close()
        } else {
          return Promise.reject(res.message)
        }
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 海关新增弹窗
    popCustomsCommodityCodeAddFormDialog() {
      this.customsCommodityCodeForm = {}
      this.customsCommodityCodeForm.isEdit = false
      this.isShowCustomsCommodityCodeMaintain = true
    },
    // 海关编辑弹窗
    popCustomsCommodityCodeEditFormDialog() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          this.$message.error(this.$t('common.tips.hasOneAtleast'))
        } else {
          console.log('getGridSelected(this.gridOptions)', getGridSelected(this.gridOptions)[0])
          self.customsCommodityCodeForm = { ...getGridSelected(this.gridOptions)[0] }
          this.customsCommodityCodeForm.isEdit = true
          self.isShowCustomsCommodityCodeMaintain = true
        }
      })
    },
    toBatchDel() {
      const self = this
      const customsCommodityCodeArray = this.getAirPortSelected()
      getGridSelectedIds(this.gridOptions, 'uuid').then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        }
        this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.comfirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          batchDelCustomsCommodityCode(customsCommodityCodeArray).then(res => {
            if (res.ok) {
              self.fetchCommodityCodeList()
              this.$message({
                type: 'success',
                message: this.$t('common.tips.deleteSuccess')
              })
            } else {
              this.$message({
                type: 'info',
                message: this.$t('common.tips.deleteSuccess')
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.tips.cancelDelete')
          })
        })
      })
    },
    getAirPortSelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length <= 0) {
        return null
      }
      return selectedRows
    },
    submitCustomsCommodityCode() {
      if (!this.toCheckCustomsCommodityCodeForm()) {
        return
      }

      if (!this.customsCommodityCodeForm.isEdit) {
        this.toAddCustomsCommodityCode()
      } else {
        this.editCustomsCommodityCode()
      }
    },
    toCheckCustomsCommodityCodeForm(opt) { // opt=> add,edit
      const { countryCode, code, commodityName } = { ...this.customsCommodityCodeForm }
      let errorMsg = ''
      if (!countryCode) {
        errorMsg += this.$t('baseInfo.customsCommodityCode.countryCodeCheck')
      }
      if (!code) {
        errorMsg += this.$t('baseInfo.customsCommodityCode.codeCheck')
      }
      if (!commodityName) {
        errorMsg += this.$t('baseInfo.customsCommodityCode.commodityNameCheck')
      }
      if (errorMsg) {
        this.$message.error(errorMsg)
        return
      } else {
        return true
      }
    },
    // 编辑海关商品编码
    editCustomsCommodityCode() {
      this.fullscreenLoading = getLoading()
      updateCustomsCommodityCode(this.customsCommodityCodeForm).then(res => {
        if (res.ok) {
          this.isShowCustomsCommodityCodeMaintain = false
          this.fullscreenLoading.close()
          this.$message({ message: this.$t('common.tips.editSuccess'), type: 'success' })
        }
      }).then(() => {
        this.fullscreenLoading.close()
        this.fetchCommodityCodeList()
      })
    },
    // 新增海关商品编码
    toAddCustomsCommodityCode() {
      addCustomsCommodityCode(this.customsCommodityCodeForm).then(res => {
        if (res.ok) {
          this.isShowCustomsCommodityCodeMaintain = false
          this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
        }
      }).then(() => {
        this.fetchCommodityCodeList()
      })
    },
    // 取消保存或者编辑
    cancelSaveOrEdit() {
      this.isShowCustomsCommodityCodeMaintain = false
      this.customsCommodityCodeForm = {}
    }
  }
}
</script>

<style scoped>

</style>
